//
// Copyright (c) 2025 Emplifi, Inc.
//

import { Plugin, type ViewDocumentSelection, WidgetToolbarRepository } from "ckeditor5";
import { getSnippetWidgetView } from "./util";

// noinspection JSUnusedGlobalSymbols
export default class SnippetToolbar extends Plugin {
  public static get requires() {
    return [WidgetToolbarRepository];
  }

  public static get pluginName() {
    return "SnippetToolbar";
  }

  public afterInit() {
    const widgetToolbarRepository = this.editor.plugins.get(WidgetToolbarRepository);
    const items = ["snippet"];
    if (!this.editor.config.get("snippet.skipOpenSnippetEditor")) {
      items.push("openSnippetEditor");
    }
    widgetToolbarRepository.register("snippet", {
      ariaLabel: this.editor.config.get("snippet.toolbarName") as string,
      items: items,
      getRelatedElement: (selection: ViewDocumentSelection) => getSnippetWidgetView(selection),
    });
  }
}
